import React, { useId } from 'react';

import { LayoutGridItem } from '@cko/primitives';
import { ContentAreas } from '../../../types/contentAreas';

type StackedViewLayoutProps = {
  contentAreas: ContentAreas;
};

export const StackedViewLayout = ({ contentAreas }: StackedViewLayoutProps) => {
  const { main } = contentAreas;
  const layoutId = useId();

  if (!main || !Array.isArray(main)) {
    throw new Error('StackedViewLayout requires an array of content areas');
  }

  return (
    <>
      {main.map((contentArea, index) => (
        <LayoutGridItem span={24} key={`${layoutId}-row-${index}`}>
          {contentArea}
        </LayoutGridItem>
      ))}
    </>
  );
};
